import React from "react";

import portadah from "../src/img/personas.jpg";
import portadal from "../src/img/fotol.png";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

import "./Quienes.css";

const valores = [
  {
    icono: "bi-hand-thumbs-up-fill",
    titulo: "Respeto",
    descripcion:
      "Valoramos la integridad de nuestros colaboradores y clientes, siempre actuando con cortesía y consideración.",
  },
  {
    icono: "bi-shield-check",
    titulo: "Honestidad",
    descripcion:
      "Mantenemos la transparencia en todas nuestras acciones, brindando un servicio confiable y fiel a nuestros principios.",
  },
  {
    icono: "bi-check-circle-fill",
    titulo: "Compromiso",
    descripcion:
      "Nos comprometemos a ofrecer productos de alta calidad y a cumplir con nuestras promesas a cada uno de nuestros clientes.",
  },
  {
    icono: "bi-lightbulb-fill",
    titulo: "Innovación",
    descripcion:
      "Siempre buscamos innovar y mejorar, con el fin de ofrecer soluciones más eficientes y vanguardistas.",
  },
  {
    icono: "bi-trophy-fill",
    titulo: "Excelencia",
    descripcion:
      "En todo lo que hacemos, nos esforzamos por alcanzar los más altos estándares de calidad y servicio.",
  },
  {
    icono: "bi-heart-fill",
    titulo: "Responsabilidad Social",
    descripcion:
      "Nos preocupamos por el bienestar de nuestra comunidad y trabajamos para contribuir al desarrollo sostenible.",
  },
];

function Quienes() {
  return (
    <div className="quienes-page">
      <Navbar />

      <main>
        {/* =====================================================
            HERO
        ===================================================== */}
        <section className="quienes-hero">
          <div className="quienes-container">
            <div className="quienes-hero-card">
              <div className="quienes-hero-content">
                <span className="quienes-kicker">
                  SOBRE NOSOTROS
                </span>

                <h1>
                  Conoce a G&amp;J Frío Industrial
                </h1>

                <p>
                  Tu aliado en repuestos, accesorios y soluciones para
                  refrigeración, línea blanca y climatización.
                </p>

                <div className="quienes-hero-features">
                  <span>
                    <i className="bi bi-patch-check-fill"></i>
                    Calidad
                  </span>

                  <span>
                    <i className="bi bi-geo-alt-fill"></i>
                    Machala, Ecuador
                  </span>

                  <span>
                    <i className="bi bi-tools"></i>
                    Soluciones técnicas
                  </span>
                </div>
              </div>

              <div className="quienes-hero-image">
                <img
                  src={portadah}
                  alt="Equipo y atención de G&J Frío Industrial"
                />
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            QUIÉNES SOMOS
        ===================================================== */}
        <section className="quienes-section">
          <div className="quienes-container">
            <div className="quienes-about-grid">
              <div className="quienes-about-image">
                <div className="quienes-image-frame">
                  <img
                    src={portadal}
                    alt="G&J Frío Industrial y Doméstico"
                  />
                </div>
              </div>

              <div className="quienes-about-content">
                <span className="quienes-section-kicker">
                  NUESTRA HISTORIA
                </span>

                <h2>
                  ¿Quiénes somos?
                </h2>

                <div className="quienes-title-line"></div>

                <p>
                  En G&amp;J Frío Industrial nos especializamos en la venta y
                  distribución de repuestos y productos de alta calidad para
                  electrodomésticos como refrigeradoras, aires acondicionados,
                  cocinas y lavadoras.
                </p>

                <p>
                  Fundada en el año 2020 en Machala, Ecuador, por Gonzalo Iván
                  Alvarado Lanchi y su hermano Juan Carlos Alvarado Lanchi,
                  G&amp;J Frío Industrial nació con el objetivo de ofrecer
                  productos tanto nacionales como importados a precios
                  competitivos.
                </p>

                <p>
                  Desde nuestros inicios, nos hemos destacado por ofrecer
                  soluciones confiables y un servicio excepcional, garantizando
                  la satisfacción de nuestros clientes.
                </p>

                <p>
                  A lo largo de los años hemos ampliado nuestro catálogo,
                  incorporando repuestos y accesorios para una gama más amplia
                  de electrodomésticos y trabajando con marcas reconocidas a
                  nivel nacional e internacional.
                </p>

                <p>
                  Creemos en el futuro, por eso seguimos comprometidos con el
                  progreso constante a través de la innovación, la
                  transparencia y la confianza en nuestro equipo y clientes.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            MISIÓN Y VISIÓN
        ===================================================== */}
        <section className="quienes-purpose-section">
          <div className="quienes-container">
            <div className="quienes-section-header">
              <div>
                <span className="quienes-section-kicker">
                  NUESTRO PROPÓSITO
                </span>

                <h2>
                  Misión y visión
                </h2>

                <p>
                  Nuestro trabajo está enfocado en crecer con responsabilidad,
                  calidad y cercanía con nuestros clientes.
                </p>
              </div>

              <div className="quienes-header-line"></div>
            </div>

            <div className="quienes-purpose-grid">
              {/* MISIÓN */}
              <article className="quienes-purpose-card">
                <div className="quienes-purpose-icon">
                  <i className="bi bi-flag-fill"></i>
                </div>

                <div className="quienes-purpose-body">
                  <span>
                    NUESTRA MISIÓN
                  </span>

                  <h3>
                    Brindar soluciones confiables
                  </h3>

                  <p>
                    Nos dedicamos a satisfacer las necesidades del mercado de
                    repuestos y productos para electrodomésticos, brindando
                    soluciones integrales a nuestros clientes.
                  </p>

                  <p>
                    Ofrecemos productos de alta calidad a precios accesibles,
                    siempre enfocados en el desarrollo y la innovación del
                    sector.
                  </p>
                </div>
              </article>

              {/* VISIÓN */}
              <article className="quienes-purpose-card">
                <div className="quienes-purpose-icon">
                  <i className="bi bi-eye-fill"></i>
                </div>

                <div className="quienes-purpose-body">
                  <span>
                    NUESTRA VISIÓN
                  </span>

                  <h3>
                    Ser una empresa referente en Ecuador
                  </h3>

                  <p>
                    Queremos posicionarnos como la empresa líder en Ecuador en
                    la distribución de repuestos y productos para
                    electrodomésticos, destacándonos por nuestra excelencia en
                    el servicio al cliente.
                  </p>

                  <p>
                    Buscamos expandir nuestra presencia en el mercado y ser la
                    primera opción de los clientes que buscan soluciones
                    confiables y eficientes.
                  </p>
                </div>
              </article>
            </div>
          </div>
        </section>

        {/* =====================================================
            VALORES
        ===================================================== */}
        <section className="quienes-values-section">
          <div className="quienes-container">
            <div className="quienes-section-header">
              <div>
                <span className="quienes-section-kicker">
                  LO QUE NOS REPRESENTA
                </span>

                <h2>
                  Nuestros valores
                </h2>

                <p>
                  Principios que forman parte de nuestro trabajo y de la
                  atención que brindamos cada día.
                </p>
              </div>

              <div className="quienes-header-line"></div>
            </div>

            <div className="quienes-values-grid">
              {valores.map((valor, index) => (
                <article
                  className="quienes-value-card"
                  key={valor.titulo}
                >
                  <div className="quienes-value-top">
                    <div className="quienes-value-icon">
                      <i className={`bi ${valor.icono}`}></i>
                    </div>

                    <span className="quienes-value-number">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                  </div>

                  <h3>
                    {valor.titulo}
                  </h3>

                  <p>
                    {valor.descripcion}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <WhatsAppButton />
    </div>
  );
}

export default Quienes;